import { DetailPage } from '../features/accounts/detail/detail-page'

/**
 * /members/:id - thin route entry.
 *
 * The page-level concerns (route guard + AppShell + BffErrorProvider) are
 * applied one level up in `app.tsx`. This file delegates rendering to
 * `features/accounts/detail/detail-page.tsx`.
 */
export function MemberDetailPage(): JSX.Element {
  return <DetailPage />
}
